//INIT
import Button from "@material-ui/core/Button"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import Typography from "@material-ui/core/Typography"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk"
import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
//IMPORTS
import PrintIcon from "@material-ui/icons/Print"
import PrintDisabledIcon from "@material-ui/icons/PrintDisabled"
import VisibilityIcon from "@material-ui/icons/Visibility"
import { useSnackbar } from "notistack"
import React, { useContext, useEffect, useState } from "react"
import { useDrag } from "react-dnd"
import iconClienteFiel from "../../../assets/icon-512x512.png"
import iconIfood from "../../../assets/ifood-logo.png"
import ServicosContext from "../../../contexts/servicosContext"
import RepresentanteSelector from "../../../functions/RepresentanteSelector"
import { verificarPrintQRCode } from "../../../pages/RecebedorDePedidos/functions"
import api from "../../../services/api"
import { UberIcon } from "../IntegracaoUber/assets"
import LoadingContext from "../../../contexts/loadingContext"
import IntegracaoUber from "../IntegracaoUber/IntegracaoUber"
import { Checkbox, FormControlLabel } from "@material-ui/core"

function OpcoesIniciais(props) {
    const {
        tabStatus,
        pedido,
        mudarStatusPara,
        autorizacao,
        index,
        setModalInformacoesPedido,
        setModalInformacoesPedidoIndex,
        setModalInformacoes,
        impressorasQZ,
        configuracoes,
        mandarImprimir,
        tipoPainelImpressao,
    } = props

    return (
        <>
            <span id={`opcoesCardPrimeiro_${pedido.id}`}>
                {tabStatus === "CRUD" && (
                    <Button
                        id={`buttonCancelar${pedido.id}`}
                        onClick={() => {
                            mudarStatusPara(-1, autorizacao, pedido, index)
                        }}
                        variant="contained"
                        style={{ fontSize: "80%", backgroundColor: "#dc3545", color: "white" }}
                    >
                        Cancelar
                    </Button>
                )}

                <Button
                    style={{ fontSize: "80%", margin: "5px 5px" }}
                    id={`buttonVer${pedido.id}`}
                    variant="contained"
                    onClick={e => {
                        setModalInformacoesPedido(pedido)
                        setModalInformacoesPedidoIndex(index)
                        setModalInformacoes(true)
                    }}
                >
                    <VisibilityIcon />
                </Button>

                {tabStatus === "CRUD" && (
                    <Button
                        id={`buttonAceitar${pedido.id}`}
                        onClick={async e => {
                            if (pedido.status === 1 || pedido.status === 2) {
                                //pedido ja esta aceito
                                if (configuracoes.recebedor.aceitarPedidoAutomatico) {
                                    document.getElementById(
                                        `opcoesCardPrimeiro_${pedido.id}`
                                    ).style.display = "none"
                                }

                                mudarStatusPara(7, autorizacao, pedido, index)
                                if (tipoPainelImpressao === "navegador") {
                                    mandarImprimir({
                                        pedido: pedido,
                                        texto: pedido.texto,
                                        qtd: configuracoes.user.parametros?.viasImpressao,
                                        qrcode: verificarPrintQRCode(pedido),
                                    })
                                }
                            } else {
                                //aceitar pedido
                                await mudarStatusPara(1, autorizacao, pedido, index)
                            }
                        }}
                        variant="contained"
                        style={{ fontSize: "80%", backgroundColor: "#28a745", color: "white" }}
                    >
                        {pedido.status === 1 || pedido.status === 2 ? "Preparar" : "Aceitar"}
                    </Button>
                )}
            </span>
        </>
    )
}
export default function Card(props) {
    const { configuracoes } = useContext(ServicosContext)

    const { setLoading } = useContext(LoadingContext)

    const { enqueueSnackbar } = useSnackbar()

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const {
        indexLista,
        pedido,
        indexPedido,
        autorizacao,
        mudarStatusPara,
        mandarImprimir,
        impressorasQZ,
        tabStatus,
        setModalInformacoes,
        setModalInformacoesPedidoIndex,
        setModalInformacoesPedido,
        classes,
        procurarMotoqueiros,
        solicitarEntregaFuiDelivery,
        buscarStatus,
        tipoPainelImpressao,
        listaPedidosSelecionados,
        setListaPedidosSelecionados,
    } = props

    const gerarPrevisao = () => {
        try {
            return new Date(new Date(pedido?.createdAt)?.getTime() + 3600000).getTime()
        } catch (error) {
            return null
        }
        return null
    }

    const verificarAtrasado = previsao => {
        try {
            if (configuracoes.recebedor.alertaTempoEntrega != true) {
                return false
            }
            const time = parseInt((previsao - new Date().getTime()) / 1000 / 60)
            if (time < 0) {
                return true
            }
        } catch (error) {}
        return false
    }

    const [previsao, setPrevisao] = React.useState(gerarPrevisao())
    const [atraso, setAtraso] = React.useState(verificarAtrasado(previsao))

    const [expandIntegracaoUber, setExpandIntegracaoUber] = useState(false)

    const [time, setTime] = React.useState(null)

    const [corIconeUber, setCorIconeUber] = useState()
    const [iconeUberPendente, setIconeUberPendente] = useState(false)

    React.useEffect(() => {
        //console.log('PEDIDO ATRASDO', pedido.id, atraso)
        if (configuracoes.recebedor.alertaTempoEntrega) {
            const interval = setInterval(() => {
                setTime(parseInt((previsao - new Date().getTime()) / 1000 / 60))
            }, 30000)
            return () => clearInterval(interval)
        }
    }, [time, previsao, atraso, configuracoes.recebedor.alertaTempoEntrega])

    const integradoComUber = configuracoes.user?.parametros?.possuiIntegracaoUber

    const proximoStatus = (pedido, indexLista) => {
        switch (indexLista) {
            case 2:
                if (pedido.type == "0") {
                    return 3
                } else {
                    return 6
                }
            case 3:
                return 4
            default:
                return null
        }
    }

    const classStatus = indexLista => {
        switch (indexLista) {
            case 1:
                return "statusPrimeiro"
            case 2:
                return "statusSegundo"
            case 3:
                if (pedido.status < 0) {
                    return "statusTerceiroVermelho"
                } else {
                    return "statusTerceiro"
                }
            case 4:
                if (pedido.status < 0) {
                    return "statusQuartoVermelho"
                } else {
                    return "statusQuarto"
                }

            default:
                return "statusQuartoVermelho"
        }
    }
    const classIcon = () => {
        switch (indexLista) {
            case 2:
                return classes.iconNext3
            case 3:
                return classes.iconNext4
            default:
                return {}
        }
    }
    const mudarStatus = () => {
        mudarStatusPara(proximoStatus(pedido, indexLista), autorizacao, pedido, indexPedido)
    }

    const permiteNext = () => {
        switch (indexLista) {
            case 1:
                return false
            case 4:
                return false
            default:
                return true
        }
    }
    const permiteButtons = () => {
        switch (indexLista) {
            case 1:
                return false
            default:
                return true
        }
    }

    const permiteModuloMotoqueiro = () => {
        switch (indexLista) {
            case 4:
                return false
            default:
                return true
        }
    }

    const possuiIntegracaoEntrega = () => {
        return (
            configuracoes.user.parametros.ativarFuiDelivery &&
            configuracoes.user.parametros.passwordFuiDelivery &&
            configuracoes.user.parametros.usernameFuiDelivery &&
            configuracoes.user.parametros.clienteIdFuiDelivery
        )
    }

    const [{ isDragging }, dragRef] = useDrag({
        type: "CARD",
        item: () => ({
            pedido: pedido,
            indexListaAtual: indexLista,
            indexPedido: indexPedido,
        }),
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    })
    // console.log("PEDIDO", pedido.id, pedido)

    return (
        <React.Fragment key={indexPedido}>
            {indexPedido < configuracoes.recebedor.exibicaoMaxima ? (
                <span>
                    <ListItem
                        id={`pedido-${pedido.id}`}
                        // style={{}}
                        button
                        ref={
                            pedido.status >= 1 && indexLista != 1 && tabStatus === "CRUD"
                                ? dragRef
                                : null
                        }
                        style={
                            isDragging
                                ? {
                                      border: "2px dashed rgba(0,0,0,0.2)",
                                      // paddingTop: "31px",
                                      padding: "0px 5px 0px 0px",
                                      borderRadius: "0",
                                      background: "transparent",
                                      boxShadow: "none",
                                      cursor: "grabbing",
                                      cursor: "-moz-grabbing",
                                      cursor: "-webkit-grabbing",
                                  }
                                : {
                                      padding: "0px 5px 0px 0px",
                                  }
                        }
                    >
                        <span
                            style={
                                isDragging
                                    ? {
                                          opacity: 0,
                                          alignItems: "center",
                                          width: "100%",
                                      }
                                    : {
                                          alignItems: "center",
                                          width: "100%",
                                      }
                            }
                        >
                            <ListItemText
                                onClick={e => {
                                    setModalInformacoesPedido(pedido)
                                    setModalInformacoesPedidoIndex(indexPedido)
                                    setModalInformacoes(true)
                                }}
                                primary={
                                    <React.Fragment>
                                        {
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                color="textPrimary"
                                            >
                                                {pedido.plataforma === "ifood_integracao" ? (
                                                    <img
                                                        src={iconIfood}
                                                        style={{ width: "25px" }}
                                                        alt="pedido ifood"
                                                    />
                                                ) : RepresentanteSelector.getRepresentante().isClienteFiel() ? (
                                                    <img
                                                        src={iconClienteFiel}
                                                        style={{ width: "15px" }}
                                                        alt="pedido cliente fiel"
                                                    />
                                                ) : null}

                                                <span>
                                                    {" "}
                                                    <b>#{pedido.id}</b> -{" "}
                                                    {pedido.createdAt.substring(
                                                        pedido.createdAt.indexOf(" ")
                                                    )}{" "}
                                                    {time ? "- " + time + " min" : ""}
                                                </span>

                                                {tabStatus === "CRUD" && permiteNext() ? (
                                                    <IconButton
                                                        // className={classes.botaoNext}
                                                        style={{ float: "right", padding: "5px" }}
                                                        onClick={e => {
                                                            mudarStatus()
                                                            e.stopPropagation()
                                                        }}
                                                    >
                                                        <NavigateNextIcon
                                                            style={{ fontSize: "1.3rem" }}
                                                            className={classIcon()}
                                                        />
                                                    </IconButton>
                                                ) : null}

                                                {permiteButtons() ? (
                                                    <>
                                                        {indexLista !== 4 && (
                                                            <Button
                                                                style={{
                                                                    minWidth: 0,
                                                                    width: "32px",
                                                                    height: "32px",
                                                                    float: "right",
                                                                    backgroundColor:
                                                                        "rgba(255, 255, 255, 0)",
                                                                }}
                                                                disableTouchRipple
                                                                size="small"
                                                                onClick={e => {
                                                                    e.stopPropagation()
                                                                    setListaPedidosSelecionados(
                                                                        lista => {
                                                                            return {
                                                                                ...lista,
                                                                                [pedido.id]: {
                                                                                    id: pedido.id,
                                                                                    checked:
                                                                                        !lista[
                                                                                            pedido
                                                                                                .id
                                                                                        ]?.checked,
                                                                                    indexPedido:
                                                                                        indexPedido,
                                                                                },
                                                                            }
                                                                        }
                                                                    )
                                                                }}
                                                            >
                                                                <Checkbox
                                                                    checked={
                                                                        listaPedidosSelecionados[
                                                                            pedido.id
                                                                        ]?.checked ?? false
                                                                    }
                                                                    style={{
                                                                        padding: "6px",
                                                                    }}
                                                                    size="small"
                                                                    name="efeito-sonoro"
                                                                />
                                                            </Button>
                                                        )}
                                                        <IconButton
                                                            onClick={e => {
                                                                mandarImprimir({
                                                                    pedido: pedido,
                                                                    texto: pedido.texto,
                                                                    qtd: 1,
                                                                    qrcode: verificarPrintQRCode(
                                                                        pedido
                                                                    ),
                                                                })
                                                                e.stopPropagation()
                                                            }}
                                                            style={{
                                                                color:
                                                                    configuracoes.user.parametros
                                                                        .assinaturaLimitada === true
                                                                        ? "#dc3545"
                                                                        : "#5f5f5f",
                                                                padding: "5px",
                                                                float: "right",
                                                            }}
                                                        >
                                                            {configuracoes.user.parametros
                                                                .assinaturaLimitada === true ? (
                                                                <PrintDisabledIcon
                                                                    style={{ fontSize: "1.3rem" }}
                                                                />
                                                            ) : (
                                                                <PrintIcon
                                                                    style={{ fontSize: "1.3rem" }}
                                                                />
                                                            )}
                                                        </IconButton>

                                                        <IconButton
                                                            style={{
                                                                color: "#5f5f5f",
                                                                padding: "5px",
                                                                float: "right",
                                                                width: "30.792px",
                                                                height: "30.792px",
                                                            }}
                                                            onClick={e => {
                                                                if (integradoComUber) {
                                                                    e.stopPropagation()
                                                                    setExpandIntegracaoUber(
                                                                        !expandIntegracaoUber
                                                                    )
                                                                } else {
                                                                    if (
                                                                        pedido.type !== "2" &&
                                                                        pedido.type !== "1"
                                                                    ) {
                                                                        if (
                                                                            possuiIntegracaoEntrega()
                                                                        ) {
                                                                            solicitarEntregaFuiDelivery(
                                                                                autorizacao,
                                                                                pedido
                                                                            )
                                                                        } else if (
                                                                            permiteModuloMotoqueiro() &&
                                                                            tabStatus === "CRUD"
                                                                        ) {
                                                                            procurarMotoqueiros(
                                                                                autorizacao,
                                                                                "#" +
                                                                                    pedido.idEntregador,
                                                                                [
                                                                                    pedido,
                                                                                    indexPedido,
                                                                                ]
                                                                            )
                                                                        }
                                                                        e.stopPropagation()
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                // pedido.mesa
                                                                pedido.type === "2" ? (
                                                                    <AirlineSeatReclineNormalIcon
                                                                        style={{
                                                                            fontSize: "1.3rem",
                                                                        }}
                                                                    />
                                                                ) : pedido.type === "1" ? (
                                                                    <DirectionsWalkIcon
                                                                        style={{
                                                                            fontSize: "1.3rem",
                                                                        }}
                                                                    />
                                                                ) : integradoComUber ? (
                                                                    <UberIcon
                                                                        color={corIconeUber}
                                                                        pendente={iconeUberPendente}
                                                                        onClick={e => {
                                                                            e.stopPropagation()
                                                                            setExpandIntegracaoUber(
                                                                                !expandIntegracaoUber
                                                                            )
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <MotorcycleIcon
                                                                        style={{
                                                                            fontSize: "1.3rem",
                                                                            color: pedido.idEntregador
                                                                                ? "#28a745"
                                                                                : "5f5f5f",
                                                                        }}
                                                                        onClick={e => {
                                                                            if (
                                                                                possuiIntegracaoEntrega()
                                                                            ) {
                                                                                solicitarEntregaFuiDelivery(
                                                                                    autorizacao,
                                                                                    pedido
                                                                                )
                                                                            } else if (
                                                                                permiteModuloMotoqueiro() &&
                                                                                tabStatus === "CRUD"
                                                                            ) {
                                                                                procurarMotoqueiros(
                                                                                    autorizacao,
                                                                                    "#" +
                                                                                        pedido.idEntregador,
                                                                                    [
                                                                                        pedido,
                                                                                        indexPedido,
                                                                                    ]
                                                                                )
                                                                            }
                                                                            e.stopPropagation()
                                                                        }}
                                                                    />
                                                                )
                                                            }
                                                        </IconButton>
                                                    </>
                                                ) : null}
                                            </Typography>
                                        }
                                        <Typography
                                            component="h2"
                                            color="textPrimary"
                                            className="text-capitalize"
                                        >
                                            {pedido.customer.name}
                                            {pedido.type === "2" ? " - Mesa " + pedido.mesa : ""}
                                        </Typography>
                                    </React.Fragment>
                                }
                                secondary={
                                    <>
                                        <span
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "row",
                                                height: "20px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                // className={classes.inline}
                                                color="textPrimary"
                                            >
                                                <span
                                                    className={classStatus(
                                                        atraso ? -50 : indexLista
                                                    )}
                                                >
                                                    {buscarStatus(pedido)}
                                                    {atraso ? " ATRASADO" : ""}
                                                </span>
                                            </Typography>
                                            <span>
                                                {pedido.status >= 0 && atraso != true
                                                    ? " — " + pedido.payments.name
                                                    : null}
                                            </span>
                                            {!(
                                                indexLista === 4 &&
                                                configuracoes?.user?.perfil === "DELIVERY_BASICO"
                                            ) ? (
                                                <span
                                                    style={{
                                                        // float: "right",
                                                        position: "absolute",
                                                        right: 0,
                                                        backgroundColor: "#9a9a9a",
                                                        color: "white",
                                                        borderRadius: "15px",
                                                        padding: "0px 10px",
                                                        margin: 0,
                                                    }}
                                                >
                                                    {Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    }).format(pedido.totalPrice)}
                                                </span>
                                            ) : (
                                                <></>
                                            )}
                                        </span>
                                        {configuracoes.recebedor.mostrarEndereco &&
                                            pedido.deliveryAddress.streetName !==
                                                "Buscar no local" && (
                                                <Typography variant="subtitle2">
                                                    {pedido.deliveryAddress.neighborhood} -{" "}
                                                    {pedido.deliveryAddress.streetName},{" "}
                                                    {pedido.deliveryAddress.streetNumber}
                                                </Typography>
                                            )}
                                        {configuracoes.recebedor.mostrarEntregador &&
                                            pedido.nomeEntregador && (
                                                <Typography variant="subtitle2">
                                                    Entregador: {pedido.nomeEntregador}
                                                </Typography>
                                            )}
                                    </>
                                }
                            />
                        </span>
                    </ListItem>

                    {integradoComUber && (
                        <IntegracaoUber
                            expandIntegracaoUber={expandIntegracaoUber}
                            setExpandIntegracaoUber={setExpandIntegracaoUber}
                            pedido={pedido}
                            autorizacao={autorizacao}
                            mudarStatus={mudarStatus}
                            setCorIconeUber={setCorIconeUber}
                            setIconeUberPendente={setIconeUberPendente}
                            alertStart={alertStart}
                        />
                    )}

                    {indexLista == 1 ? (
                        <OpcoesIniciais
                            tabStatus={tabStatus}
                            tipoPainelImpressao={tipoPainelImpressao}
                            pedido={pedido}
                            mudarStatusPara={mudarStatusPara}
                            autorizacao={autorizacao}
                            indexPedido={indexPedido}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            setModalInformacoesPedidoIndex={setModalInformacoesPedidoIndex}
                            setModalInformacoes={setModalInformacoes}
                            impressorasQZ={impressorasQZ}
                            configuracoes={configuracoes}
                            mandarImprimir={mandarImprimir}
                        />
                    ) : null}

                    <Divider id={`divider-${pedido.id}`} style={{ margin: "1em 0 0 0" }} />
                </span>
            ) : null}
        </React.Fragment>
    )
}
